<template>
  <div class="wc-single-page-form__container mx-auto my-4">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'WCSinglePageFormContainer',
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-single-page-form__container {
  width: 100%;
}

@include media-breakpoint-up(md) {
  .wc-single-page-form__container {
    width: 35rem;
  }
}
</style>
